
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {CustomsPackingGroup, Money} from "@/model/HqPackingListModels";

/*配置柜型中的主包装列表*/
@Component({
  name: "FactoryLoadingPlanHqPackingListInfoTable"
})

export default class extends Vue {

  @Prop({required: true}) private data: HqPackingListItem;
  @Prop({required: true}) private needCheckBoxInComponents: false;
  // @Prop({required: true}) private StateForItems: false;
  // @Prop({required: true}) private ValueForItems: false;
  @Prop({required: false, default: false}) private showHqPackingListStatistics;
  @Prop({required: true}) private factoryLoadingPlanPackingInfo: any;
  @Prop({required: false}) private selectContainerNumber: any;
  private listLoading = true;
  private factoryName: string = null;
  private code: string = null;
  private pltCount: string = null;
  private ctnCount: string = null;
  private totalSecondaryCtnQuantity: number = null;
  private totalProductQuantity: number = null;
  private remark: string = null;
  private tableData: CustomsPackingItem[] = [];
  private StateForItems = false;
  private ValueForItems = false;

  @Watch("data", { deep: true, immediate: true })
  private watchData() {
    this.factoryName = this.data.factoryName;
    this.code = this.data.code;
    if (this.showHqPackingListStatistics) {
      this.pltCount = this.data.pltCount;
      this.ctnCount = this.data.ctnCount;
      this.totalSecondaryCtnQuantity = this.data.totalSecondaryCtnQuantity;
      this.totalProductQuantity = this.data.totalProductQuantity;
      this.remark =this.remark? this.data.remark.filter(r => r.remark).map(value => `${value.remark}:${value.value}`).join(","): null;
      this.listLoading = false;
    }
    this.tableData = this.data.customsPackingItems;
    if(this.selectContainerNumber) {
      this.allSelectContainerNumber();
    }
  }
  // 为什么这么写呢
  // 之前是前端处理的这个需求
  // 后面要请求接口了
  // 但是还能用
  // 虽然比较繁杂
  // 不过能用就行了
  // @Watch("selectContainerNumber", { deep: true, immediate: true })
  // 需求确实傻波依
  // 不说了
  // 寄
  // 直接还得改
  // private watchSelectContainerNumber() {
  //   if(this.selectContainerNumber) {
  //     this.tableData.map(ex  => {
  //       if(ex.customsPackingChildernItems && ex.customsPackingChildernItems.length > 0) {
  //         if(ex.containerNumber === this.selectContainerNumber) {
  //           ex.select = true;
  //         } else {
  //           ex.select = false;
  //         }
  //         ex.customsPackingChildernItems.map(item => {
  //           if(item.containerNumber === this.selectContainerNumber) {
  //             item.select = true;
  //           } else {
  //             item.select = false;
  //           }
  //         })
  //       } else {
  //         if(ex.containerNumber === this.selectContainerNumber) {
  //           ex.select = true;
  //         } else {
  //           ex.select = false;
  //         }
  //       }
  //     })
  //   } else {
  //     this.tableData.map(ex  => {
  //       if(ex.customsPackingChildernItems && ex.customsPackingChildernItems.length > 0) {
  //         ex.select = false;
  //         ex.customsPackingChildernItems.map(item => {
  //           item.select = false;
  //         })
  //       } else {
  //         ex.select = false;
  //       }
  //     })
  //   }
  // }
  private allSelectContainerNumber() {
    if(this.selectContainerNumber) {
      this.tableData.map(ex  => {
        if(ex.customsPackingChildernItems && ex.customsPackingChildernItems.length > 0) {
          ex.select = true;
          ex.customsPackingChildernItems.map(item => {
            item.select = true;
          })
        } else {
          ex.select = true;
        }
      })
    } else {
      this.tableData.map(ex  => {
        if(ex.customsPackingChildernItems && ex.customsPackingChildernItems.length > 0) {
          ex.select = false;
          ex.customsPackingChildernItems.map(item => {
            item.select = false;
          })
        } else {
          ex.select = false;
        }
      })
    }
  }

  private getRowKey(row) {
    return row.id;
  }
  private onHqPackingListRowSelectionChange(checked,hqPackListItem) {
    this.$emit('onHqPackingListRowSelectionChange',checked,hqPackListItem);
    this.getStateForItems(hqPackListItem);
    this.getValueForItems(hqPackListItem);
  }
  private onCustomsPackingRowSelectionChange(row,hqPackListItem) {
    this.$emit('onCustomsPackingRowSelectionChange',row,hqPackListItem);
    this.getStateForItems(hqPackListItem);
    this.getValueForItems(hqPackListItem);
  }
  private getContaninerTypeCode(id) {
    // this.$emit('getContaninerTypeCode',id)
    const containerTypeCode = this.factoryLoadingPlanPackingInfo.configuredContainers.filter((c) => c.id === id)[0];
    // console.log('因该返回的数据',containerTypeCode.name + "-" + containerTypeCode.containerTypeCode);
    return containerTypeCode.name + "-" + containerTypeCode.containerTypeCode;
  }
  private getStateForItems(hqPackListItem) {
    if(hqPackListItem.customsPackingItems && hqPackListItem.customsPackingItems.length > 0) {
      if(hqPackListItem.customsPackingItems.findIndex(e => e.select === true) === -1 || hqPackListItem.customsPackingItems.findIndex(e => e.select === false) === -1) {
        // return false
        this.StateForItems = false;
      } else {
        // return true
        this.StateForItems = true;
      }
    }
  }

  private getValueForItems(hqPackListItem) {
    console.log('hqPackListItem',hqPackListItem)
    if(hqPackListItem.customsPackingItems && hqPackListItem.customsPackingItems.length > 0) {
      if(hqPackListItem.customsPackingItems.findIndex(e => e.select === false) === -1) {
        // return true
        this.ValueForItems = true;
      } else {
        // return false
        this.ValueForItems = false;
      }
    }
  }
}

export class HqPackingListItem {
  id: string;
  parentId: string;
  factoryName: string;
  code: string;
  remark: Money[];
  pltCount: string;
  ctnCount: string;
  totalProductQuantity: number;
  totalSecondaryCtnQuantity: number;
  customsPackingItems: CustomsPackingItem[] = [];
  toggleSelection: any;
}

export class CustomsPackingItem {
  id: string;
  hqPackingListId: string;
  code: string;
  grossWeight: string;
  netWeight: string;
  volume: string;
  totalAmount: string;
  totalProductQuantity: number;
  productInfoItems: ProductItemModel[] = [];
  configuredContainerId: string;
  selected: boolean;
  select: boolean;
  selectable: boolean;
  groupId: string;
  customsPackingChildernItems: CustomsPackingItem[];
  containerTypeCode: string;
  containerNumber: string;
}

class ProductItemModel {
  id: string;
  secondaryPackingId: string;
  description: string;
  declarationDescription: string;
  unitPrice: number;
  totalNumberPcs: number;
}

class ContainerInfoModel {
  id: string;
  containerNumber: string;
  containerTypeCode: string;
  loadingInOneOrMorePlaces: true;
  name: string;
  sealNumber: string;
  value: string;
  volume: string;
}

